import { render } from "./SummaryBillComponent.vue?vue&type=template&id=5f6e0406&scoped=true"
import script from "./SummaryBillComponent.vue?vue&type=script&lang=js"
export * from "./SummaryBillComponent.vue?vue&type=script&lang=js"

import "./SummaryBillComponent.vue?vue&type=style&index=0&id=5f6e0406&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6e0406"]])

export default __exports__